<span>{{ column.description }}</span> <input type="text" disabled class="form-control" placeholder="Text" />
